import {ResponseResType} from "../../types/common/response";
import {baseApi} from "../../util/axiosConfig";
import {
  CreatePostApiProps,
  CreatePostReplyApiProps,
  PostEntry,
  ReadPostApiProps,
  ReplyEntry,
  UpdatePostApiProps,
  UpdatePostReplyApiProps
} from "../../types/support/board";


const url = "api/customer/support/post/";

/**
 * 게시판 목록 불러오기
 * @returns
 */
export async function readPostApi(data:ReadPostApiProps): Promise<
  ResponseResType<{ postList: PostEntry[], totalCount: number }>
> {
  const response = await baseApi.post(url + "read_post", data);

  return response?.data;
}

/**
 * 게시판 상세조회
 * @returns
 */
export async function readPostDetailApi(data:string): Promise<
    ResponseResType<{ postDetailRes: PostEntry }>
> {
  const response = await baseApi.post(url + "read_post_detail", {postId: data});

  return response?.data;
}



/**
 * 게시판 삭제
 * @returns
 */
export async function deletePostApi(data:string[]): Promise<
    ResponseResType<any>
> {
  const response = await baseApi.post(url + "delete_post", {postIdList: data});

  return response?.data;
}

/**
 * 게시판 답글 삭제
 * @returns
 */
export async function deletePostReplyApi(data:string): Promise<
    ResponseResType<any>
> {
  const response = await baseApi.post(url + "delete_post_reply", {postReplyId: data});

  return response?.data;
}

/**
 * 게시판 게시글 생성
 * @returns
 */
export async function createPostApi(data:CreatePostApiProps): Promise<
    ResponseResType<PostEntry>
> {
  const formData = new FormData();
  formData.append("title", data.title);
  formData.append("body", data.body);
    (data.fileList??[]).forEach((item) => {
        formData.append("fileList", item.file);
    });
  const response = await baseApi.post(url + "create_post", formData,{
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response?.data;
}


/**
 * 게시판 게시글 수정
 * @returns
 */
export async function updatePostApi(data:UpdatePostApiProps): Promise<
    ResponseResType<PostEntry>
> {
  const formData = new FormData();
  formData.append("postId", data.postId);
  formData.append("title", data.title);
  formData.append("body", data.body);
  (data.fileList??[]).forEach((item) => {
    formData.append("fileList", item.file);
  });
  (data.fileKeyList??[]).forEach((item) => {
    formData.append("fileKeyList", item);
  })
  const response = await baseApi.post(url + "update_post", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response?.data;
}

/**
 * 게시판 답글 수정
 * @returns
 */
export async function updatePostReplyApi(data:UpdatePostReplyApiProps): Promise<
    ResponseResType<ReplyEntry>
> {
  const formData = new FormData();
  formData.append("postReplyId", data.postReplyId);
  formData.append("body", data.body);
  (data.fileList??[]).forEach((item) => {
    formData.append("fileList", item.file);
  });
  (data.fileKeyList??[]).forEach((item) => {
    formData.append("fileKeyList", item);
  })
  const response = await baseApi.post(url + "update_post_reply", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response?.data;
}

/**
 * 게시판 답글 신규저장
 * @returns
 */
export async function createPostReplyApi(data:CreatePostReplyApiProps): Promise<
    ResponseResType<ReplyEntry>
> {
  const formData = new FormData();
  formData.append("postId", data.postId);
  formData.append('isMain', data.isMain);
  formData.append("body", data.body);
  (data.fileList??[]).forEach((item) => {
    formData.append("fileList", item.file);
  });
  const response = await baseApi.post(url + "create_post_reply", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response?.data;
}